import type { ReactNode } from "react";

/**
 * 숫자 포맷 지정자(%d, %1$d, %2$d, %i 등)를 values 로 치환한다.
 * (payments 네임스페이스엔 현재 미사용이나 all.json 등 다른 키 대비 충실 이관)
 */
export const replaceNumericPlaceholders = (
  rawHtml: string,
  values: Record<string, ReactNode | string>
): string => {
  return rawHtml.replace(/%(\d+\$)?[di]/g, (match, positional) => {
    if (!positional) {
      return String(values["%d"] ?? match);
    }
    const index = parseInt(positional, 10) - 1;
    const key = Object.keys(values)[index];
    return key !== undefined ? String(values[key]) : match;
  });
};
